import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../WmsPutAway.css";
import { ArrowForwardIos } from "@mui/icons-material";

function WmsPutAway_BreadCrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid ">
      {vPathName === "/WmsPutAway" ? (
        <div>
          <span className="breadcrumb-not-active ">WmsPutAway </span>
        </div>
      ) : vPathName === "/WmsPutAwayDetail" ? (
        <div className={"d-flex align-items-center"}>
          <Link
            to="/WmsPutAway"
            state={location}
            className={"breadcrumb-active mr-2"}
          >
            WmsPutAway
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1px" }} />
          <div>
            <span className="breadcrumb-not-active">
              WmsPutAwayDetail{" "}
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default WmsPutAway_BreadCrumbs;
